import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ProjectsPreviewSection() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-background-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center border border-primary-400/40 rounded-full px-4 py-1.5 mb-6">
            <span className="text-primary-400 text-xs font-semibold uppercase tracking-wider">{t('projects.badge')}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold font-heading text-white max-w-3xl mx-auto leading-tight">
            {t('projects.title')}
          </h2>
        </div>
        <div className="space-y-6">
          {[1, 0, 2].map((idx) => {
            const project = t(`projects.list.${idx}`, { returnObjects: true }) as Record<string, string>;
            const images = [
              'https://storage.helloreaddy.io/project_files/dd4db55e-adff-421a-ab07-f57f9542cdee/067bfa09-91c0-4ed0-85bb-87d4b8c7cbdb_compressed_ChatGPT-Image-3-aot-2026-15_52_54.webp',
              'https://storage.helloreaddy.io/project_files/dd4db55e-adff-421a-ab07-f57f9542cdee/02f8402e-c227-44d6-89eb-1443feba80f5_compressed_Capture-dcran-2026-08-05-164920.webp',
              'https://readdy.ai/api/search-image?query=Black%20African%20fiber%20optic%20cable%20deployment%20technicians%20pulling%20optical%20fiber%20cables%20through%20urban%20streets%20in%20Africa%2C%20professional%20dark-skinned%20telecom%20workers%20installing%20modern%20telecommunications%20infrastructure%20with%20professional%20equipment%2C%20bright%20daylight%20photography%20showing%20large-scale%20network%20expansion&width=932&height=560&seq=proj-tel-fibre-01&orientation=landscape',
            ];
            return (
              <div
                key={idx}
                className="group bg-background-800/60 rounded-3xl overflow-hidden border border-white/10 hover:border-primary-500/30 transition-all duration-500"
              >
                <div className="grid lg:grid-cols-2 gap-0">
                  <div className="p-8 lg:p-10 flex flex-col justify-center order-2 lg:order-1">
                    <div className="flex items-center gap-3 mb-4">
                      <span className="inline-flex items-center border border-primary-400/40 rounded-full px-3 py-1 text-xs text-primary-400 font-medium uppercase">
                        {project.category}
                      </span>
                      <span className="inline-flex items-center border border-background-600 rounded-full px-3 py-1 text-xs text-background-300 font-medium">
                        {project.year}
                      </span>
                    </div>
                    <h3 className="text-2xl font-bold font-heading text-white mb-4">
                      {project.title}
                    </h3>
                    <p className="text-background-300 leading-relaxed mb-6">
                      {project.description}
                    </p>
                    <Link
                      to="/projets"
                      className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-950 px-5 py-2.5 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap w-fit"
                    >
                      {t('projects.viewDetails')}
                      <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                    </Link>
                  </div>
                  <div className="order-1 lg:order-2 h-64 lg:h-auto">
                    <img
                      src={images[idx]}
                      alt={project.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}